import { render, staticRenderFns } from "./UserTeamList.vue?vue&type=template&id=2ec7ac60&"
import script from "./UserTeamList.vue?vue&type=script&lang=js&"
export * from "./UserTeamList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports